"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEVERAGEABLE_ASSETS_OPTIONS = exports.LeverageableAssets = exports.EQUITY_RAISED_OPTIONS = exports.EquityRaised = void 0;
const legacy_ui_1 = require("@hum/legacy-ui");
var EquityRaised;
(function (EquityRaised) {
    EquityRaised["Bootstrapped"] = "bootstrapped";
    EquityRaised["Between0And5M"] = "between_0_and_5_m";
    EquityRaised["Between5And15M"] = "between_5_and_15_m";
    EquityRaised["Between15And25M"] = "between_15_and_25_m";
    EquityRaised["Between25And50M"] = "between_25_and_50_m";
    EquityRaised["Between50And100M"] = "between_50_and_100_m";
    EquityRaised["MoreThan100M"] = "more_than_100_m";
})(EquityRaised = exports.EquityRaised || (exports.EquityRaised = {}));
exports.EQUITY_RAISED_OPTIONS = (0, legacy_ui_1.selectOptionsFromMap)({
    [EquityRaised.Bootstrapped]: 'Bootstrapped',
    [EquityRaised.Between0And5M]: '$0–$5M',
    [EquityRaised.Between5And15M]: '$5–$15M',
    [EquityRaised.Between15And25M]: '$15–$25M',
    [EquityRaised.Between25And50M]: '$25–$50M',
    [EquityRaised.Between50And100M]: '$50–$100M',
    [EquityRaised.MoreThan100M]: '$100M+',
});
var LeverageableAssets;
(function (LeverageableAssets) {
    LeverageableAssets["NotApplicable"] = "not_applicable";
    LeverageableAssets["AccountsReceivable"] = "accounts_receivable";
    LeverageableAssets["Inventory"] = "inventory";
    LeverageableAssets["RealEstate"] = "real_estate";
    LeverageableAssets["CapitalEquipment"] = "capital_equipment";
})(LeverageableAssets = exports.LeverageableAssets || (exports.LeverageableAssets = {}));
exports.LEVERAGEABLE_ASSETS_OPTIONS = (0, legacy_ui_1.selectOptionsFromMap)({
    [LeverageableAssets.NotApplicable]: 'N/A',
    [LeverageableAssets.AccountsReceivable]: 'Accounts Receivable',
    [LeverageableAssets.Inventory]: 'Inventory',
    [LeverageableAssets.RealEstate]: 'Real Estate',
    [LeverageableAssets.CapitalEquipment]: 'Capital Equipment',
});
//# sourceMappingURL=financials.js.map